import React from "react";
import { Modal } from "react-bootstrap";

import "./ModalPopup.scss";


const { useRef } = React;

export function ModalPopup(props) {
    const childRef = useRef();

    function onUpdate(e) {
        console.log(e)
        childRef.current.updatefromParent();
    }

    return (
        <Modal
            show={props.show}
            onHide={props.onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {props.title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {/* <h4></h4> */}
                {props.component ? <props.component rowData={props.data} list={props.list} onUpdate={props.onUpdate} onHide={props.onHide} ref={childRef} isLoading={props.isLoading} errorMsgUpdate={props.errorMsgUpdate} auth={props.auth}/> : props.message}
            </Modal.Body>
            <Modal.Footer>
                <button className="btn common-button" onClick={props.actionlabel === "Delete" ? () => props.triggerDelete(props.data) : ((props.onUpdateToParent) ? props.onUpdateToParent : onUpdate)}>{props.actionlabel}</button>
                <button className="btn common-cancel-button" onClick={props.onHide}>Close</button>
            </Modal.Footer>
        </Modal>
    )
}